import React from "react";
import { Route, Router, Switch } from "react-router";
import { history } from "./services/historyService";
import consts from "./utils/consts";
import { Criterias, Home, Schedules, InventoryUpdates, DisplayRequired } from "./Pages";
import { Container } from "@material-ui/core";
import appStyles from "./AppStyles";
import DrawerMenu from "./components/DrawerMenu/DrawerMenu";
import { ReplenishmentAppBar, AppBarHeader, AppBarUserDetails } from "./components/AppBar";
import { useMsal } from "@azure/msal-react";
import PageBreadcrumbs from "./components/Breadcrumbs/PageBreadcrumbs";
import Inventory from "./Pages/Inventory";

const AppRouter: React.FC = () => {
	const classes = appStyles();
	const { instance } = useMsal();

	return (
		<Router history={history}>
			<ReplenishmentAppBar
				centreChildren={<AppBarHeader />}
				rightChildren={
					<AppBarUserDetails
						logout={() =>
							instance.logoutRedirect({
								account: instance.getActiveAccount(),
							})
						}
					/>
				}
			/>

			<DrawerMenu />
			<main className={classes.content}>
				<Container className={classes.pageContainer} maxWidth={false}>
					<Switch>
						<Route path={consts.routerPath.home} exact component={Home} />
						{/* <Route path={consts.routerPath.orders} exact component={Orders} /> */}
						<Route path={consts.routerPath.schedules} exact component={Schedules} />
						<Route path={consts.routerPath.criteria} exact component={Criterias} />
						<Route path={consts.routerPath.inventory} exact component={Inventory} />
						<Route path={consts.routerPath.inventoryUpdates} exact component={InventoryUpdates} />
						<Route path={consts.routerPath.inventoryDisplayRequired} exact component={DisplayRequired} />
						<Route path="*">
							<PageBreadcrumbs />
							<div>Page not found!</div>
						</Route>
					</Switch>
				</Container>
			</main>
		</Router>
	);
};

export default AppRouter;
